export class TransactionAttributeDto {
  id: string;
  name: string;
  value: string;

  constructor(d?: TransactionAttributeDto) {
    if (!d) {
      return;
    }
    this.id = d.id;
    this.name = d.name;
    this.value = d.value;
  }
}
